var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconInfo = function SvgIconInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6.421,
    height: 14.058,
    viewBox: "0 0 6.421 14.058"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5846",
    "data-name": "Group 5846",
    transform: "translate(-10 -3.688)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32782",
    "data-name": "Path 32782",
    d: "M-23496.457-22515.57h-1.756v-7.672H-23501V-22525h3.664a.877.877,0,0,1,.877.879Z",
    transform: "translate(23510.998 22532.227)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_121",
    "data-name": "Line 121",
    d: "M6.15.757H0V-1H6.15Z",
    transform: "translate(10.271 16.988)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_477",
    "data-name": "Ellipse 477",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(11.865 3.717)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_477_-_Outline",
    "data-name": "Ellipse 477 - Outline",
    d: "M1.318,0A1.318,1.318,0,1,1,0,1.318,1.318,1.318,0,0,1,1.318,0Z",
    transform: "translate(12.028 3.688)",
    fill: "#ececec"
  }))));
};
export default SvgIconInfo;